module.exports = __webpack_public_path__ + "static/media/catalyx.ba884552.jpg";